import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';
import * as moment from 'moment';
import { CNHealthAgent } from './cnhealthagent';
import { ODBService } from '../services/odb.service';

export enum CNTreatmentType {
    None = 'None',
    Kine = 'Kine',
    Logo = 'Logo',
    Ophtalmo = 'Ophtalmo',
    Cardio = 'Cardio'
}

@RegisterItem()
export class CNTreatment extends CNItem {

    private thePrescriber: CNHealthAgent;

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNTreatment';
        this.loaded.subscribe(treatment => {
            if (treatment.getProperty('prescriberId') !== null && treatment.getProperty('prescriberId').length !== 0) {
                // Load prescriber
                const odb = ODBService.getInstance().itemById(treatment.getProperty('prescriberId')).subscribe(item => {
                    this.thePrescriber = item as CNHealthAgent;
                });
            }
        });
    }

    get type(): CNTreatmentType {
        return CNTreatmentType.None;
    }

    set description(desc: string) {
        this.setProperty('description', desc);
    }

    get description(): string {
        return this.getProperty('description');
    }

    get date(): Date {
        if (this.getProperty('date')) {
            return moment(this.getProperty('date'), 'DD/MM/YYYY').toDate();
        }
        return this.createddate;
    }

    get startDate(): Date {
        if (this.getProperty('StartDate') === null) {
            this.setProperty('StartDate', moment(new Date()).format('DD/MM/YYYY'));
        }
        return moment(this.getProperty('StartDate'), 'DD/MM/YYYY').toDate();
    }

    set startDate(date: Date) {
        this.setProperty('StartDate', moment(date).format('DD/MM/YYYY'));
    }

    get endDate(): Date {
        if (this.getProperty('EndDate') === null) {
            this.setProperty('EndDate', moment(new Date()).format('DD/MM/YYYY'));
        }
        return moment(this.getProperty('EndDate'), 'DD/MM/YYYY').toDate();
    }

    set endDate(date: Date) {
        this.setProperty('EndDate', moment(date).format('DD/MM/YYYY'));
    }

    get isActive(): boolean {
        return moment(this.endDate).add(1, 'day').toDate() >= new Date() ? true : false;
    }

    get prescribedDate(): Date {
        if (this.getProperty('PrescribedDate') === null) {
            this.setProperty('PrescribedDate', moment(new Date()).format('DD/MM/YYYY'));
        }
        return moment(this.getProperty('PrescribedDate'), 'DD/MM/YYYY').toDate();
    }

    set prescribedDate(date: Date) {
        this.setProperty('PrescribedDate', moment(date).format('DD/MM/YYYY'));
    }

    set prescriber(prescriber: CNHealthAgent) {
        this.setProperty('prescriberDesc', prescriber.description);
        this.setProperty('prescriberId', prescriber.id);
        this.thePrescriber = prescriber;
    }

    get prescriber(): CNHealthAgent {
        return this.thePrescriber;
    }

    get prescriberDescription(): string {
        return this.getProperty('prescriberDesc');
    }

    public clone(): any {
        return new CNTreatment();
    }
}
